import { render, staticRenderFns } from "./MyLastParticipations.vue?vue&type=template&id=3815b681"
import script from "./MyLastParticipations.vue?vue&type=script&lang=js"
export * from "./MyLastParticipations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports